module.exports = {
    'Init': require('./init'),
    'AlwaysPopup': require('./always-popup'),
    'TimeOnPagePopup': require('./time-on-page-popup'),
    'TimeOnSitePopup': require('./time-on-site-popup'),
    'ScrollDistancePopup': require('./scroll-distance-popup'),
    'SetPopupCookie': require('./set-popup-cookie'),
    'RegisterPopupCTAEvents': require('./register-popup-cta-events'),
    'ClosePopup': require('./close-popup')
};